/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.branding.rpc.BrandKitRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const listByPortalIdRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'listByPortalId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABwo2cos869epwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'k-sEEoU1S1KMGrYcg4dkYZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByBusinessUnitRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'getByBusinessUnit',
  auth: 'app',
  fingerprint: 'B7tcu50ypXeMGrYcg4dkYZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPrimaryRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'getPrimary',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACMGrYcg4dkYZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'umewbeb1B9mMGrYcg4dkYZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'ItSqwWUkyveMGrYcg4dkYZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: '_z2BF1W-AlWOUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const makePrimaryRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandKitRpc',
  rpcName: 'makePrimary',
  auth: 'app',
  fingerprint: 'dec8lOQJcOuOUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};